module.exports = "https://static.energy5.com/_next/static/images/siemensEnergy-37a3021f6a12e94b004c947b481af7fa.png";